import { throwIfMissing } from '../utils/action.utils';
import { CALL_API } from '../login/api.middleware';
import { CATALOG_SERVICE_URL } from '../constants/api';
import * as type from '../constants/ActionTypes';



export function fetchProducts({
  salesGroupIdList = throwIfMissing('salesGroupIdList'),
}) {

    return {
    [CALL_API]: {
      endpoint: `${CATALOG_SERVICE_URL}/products/view/relations`,
      types: [
        type.PRODUCT_LIST_REQUEST,
        type.PRODUCT_LIST_SUCCESS,
        type.PRODUCT_LIST_FAILURE
      ],
      authenticated: true,
      params: {
        salesGroupIdList: salesGroupIdList,
        subProduct: false,
        affiliateProductStatus: 'active',
        relations: 'salesGroupIds,venues'
      },
    }
  };
}